import styled from 'styled-components/macro';

const ParagraphText = styled.p`
	font-size: 0.85rem;
	text-align: left;
	color: var(--gray-color);
	line-height: 1.5;
	font-weight: 500;
	@media screen and (min-width: 2000px) {
		font-size: 1.1rem;
	}
`;

export default ParagraphText;
